module.exports = __webpack_public_path__ + "img/green_hired.e47c46f2.svg";